import { Link } from 'react-router-dom';
import { featuredVideos } from '@/mocks/videos';

export default function VideoGridSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8 bg-background-100">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10 md:mb-14">
          <div>
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-primary-100 text-primary-800 text-xs font-medium rounded-full mb-4">
              <i className="ri-fire-line" />
              精选推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950">
              热门视频推荐
            </h2>
          </div>
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredVideos.map((video, index) => (
            <Link
              key={video.id}
              to={`/category/${video.category}`}
              className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300 hover:shadow-lg transition-all duration-300"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-foreground-950/0 group-hover:bg-foreground-950/20 transition-colors duration-300 flex items-center justify-center">
                  <span className="w-12 h-12 rounded-full bg-primary-500/90 text-white flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300 shadow-lg">
                    <i className="ri-play-fill text-xl" />
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2 py-1 bg-foreground-950/70 text-white text-xs rounded-md font-medium">
                  {video.duration}
                </span>
                {index === 0 && (
                  <span className="absolute top-3 left-3 px-2 py-1 bg-primary-500 text-white text-xs rounded-md font-medium">
                    热门
                  </span>
                )}
              </div>

              <div className="p-4 md:p-5">
                <h3 className="text-foreground-900 font-semibold text-base mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {video.title}
                </h3>
                <div className="flex items-center gap-3 text-xs text-foreground-500 flex-wrap">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line" />
                    {video.views}
                  </span>
                  <span className="flex items-center gap-1 text-amber-500">
                    <i className="ri-star-fill" />
                    {video.rating}
                  </span>
                  <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 rounded-full">
                    {video.categoryName}
                  </span>
                </div>
                {video.description && (
                  <p className="mt-2.5 text-xs text-foreground-500 line-clamp-2 leading-relaxed">
                    {video.description}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}